/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Attachment } from './attachment';
import type { AttachmentDeleteResponseEtag } from './attachmentDeleteResponseEtag';

/**
 * Response for the deletion of an attachment
 */
export interface AttachmentDeleteResponse {
  data: Attachment;
  /** New ETag of the module submission */
  etag?: AttachmentDeleteResponseEtag;
}
